import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppRoutesNames } from './core-route-names';
import { BasicAuthGuard } from '@geekbears/gb-ngrx-auth-basic';
import { OnFirstTimeLoginGuard } from './guards';

const routes: Routes = [
  {
    path: '',

    redirectTo: AppRoutesNames.dashboard,
    pathMatch: 'full',
  },
  {
    path: AppRoutesNames.dashboard,
    canActivate: [BasicAuthGuard, OnFirstTimeLoginGuard],
    runGuardsAndResolvers: 'always',
    loadChildren: () =>
      import('../../modules/admin/admin-core/admin-core.module').then(
        (m) => m.AdminCoreModule
      ),
  },

  {
    path: 'shared',
    loadChildren: () =>
      import('../../modules/shared/shared.module').then((m) => m.SharedModule),
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'top',
      useHash: false,
    }),
  ],
  exports: [RouterModule],
})
export class CoreRoutingModule {}
